import { Component, OnInit } from "@angular/core";
import { ButtonComponent, ButtonType, DividerComponent, InputTextComponent, ThemeService } from "design-system";
import {
	AbstractControl,
	FormControl,
	FormGroup,
	ReactiveFormsModule,
	ValidationErrors,
	ValidatorFn,
	Validators,
} from "@angular/forms";

import { NgOptimizedImage } from "@angular/common";
import { RouterLink } from "@angular/router";
import { AuthenticationService } from "../../services/authentication.service";
import { PasswordStrengthComponent } from "design-system";
import { github } from "design-system";

@Component({
	selector: "lib-sign-up",
	imports: [
		ButtonComponent,
		InputTextComponent,
		DividerComponent,
		ReactiveFormsModule,
		NgOptimizedImage,
		RouterLink,
		PasswordStrengthComponent,
	],
	templateUrl: "./sign-up.component.html",
	styleUrl: "./sign-up.component.css",
})
export class SignUpComponent implements OnInit {
	submitButtonLoading = false;
	credentials = new FormGroup({
		email: new FormControl("", [Validators.required, Validators.email]),
		password: new FormControl("", [Validators.required]),
	});
	protected showPasswordStrength = false;
	protected passwordValidators = [Validators.minLength(8), this.numberValidator()];
	constructor(
		private themeService: ThemeService,
		private authService: AuthenticationService,
	) {}
	protected readonly ButtonType = ButtonType;
	ngOnInit() {
		this.themeService.setTheme("dark");
	}
	submit() {
		if (this.credentials.valid && this.credentials.value.email && this.credentials.value.password) {
			this.authService.signUp(this.credentials.value.email, this.credentials.value.password);
		}
	}

	protected readonly github = github;
	protected validationMessages = {
		minlength: "Must be at least 8 characters long.",
		number: "Must contain at least one digit.",
	};
	protected regexRules = [
		{ label: "Must contain at least one special character", pattern: /[!@#$%^&*(),.?\":{}|<>]/ },
	];

	// 4) Custom validator that checks for at least one digit
	numberValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const val = (control.value || "") as string;
			return /\d/.test(val) ? null : { number: true };
		};
	}
}
